// extracted by mini-css-extract-plugin
export default {"mandatory":"Input_mandatory__cEt-6","errorMessage":"Input_errorMessage__bBXSs","errorBorder":"Input_errorBorder__WlRTg","placeholder":"Input_placeholder__8AQ8k"};